import PropTypes from 'prop-types';

export default {
  contract_name: PropTypes.string,
  clearDiscountInReservationFlow: PropTypes.func,
  modalKey: PropTypes.string,
};
